import React, { useEffect, useRef, useCallback, useState } from 'react';
import SuperGlobe from "./superGlobe";
import { mars } from './resources'
import Timer from '../time';
import { setFont } from '../utils';
import { loadAllResource } from './utils';
import SuperGround from './superGround';

function App () {
  const globeInstanceRef = useRef<SuperGlobe>();
  const globeCanvasRef = useRef<HTMLCanvasElement>(null);

  const groundInstanceRef = useRef<SuperGround>();
  const groundCanvasRef = useRef<HTMLCanvasElement>(null);
  
  const mountRef = useRef<HTMLDivElement>(null);
  const [mode, setMode] = useState<number>(0)

  useEffect(() => {

    const resManager = loadAllResource(mars);
    
    if (
      groundCanvasRef.current !== null &&
      mountRef.current !== null &&
      globeCanvasRef.current !== null &&
      mountRef.current !== null
    ) {
        // -----------
        groundCanvasRef.current.width = window.innerWidth;
        groundCanvasRef.current.height = window.innerHeight;
        const groundInstance = new SuperGround(
          groundCanvasRef.current,
          mars,
          resManager
        );
        mountRef.current.appendChild(groundInstance.renderer.domElement);
        groundInstance.animate();
        groundInstanceRef.current = groundInstance;
        groundInstanceRef.current.updateSize();
        (window as any).groundInstance = groundInstance;

        // -----------
        globeCanvasRef.current.width = window.innerWidth;
        globeCanvasRef.current.height = window.innerHeight;
        const globeInstance = new SuperGlobe(
          globeCanvasRef.current,
          mars,
          groundInstance,
          resManager
        );
        mountRef.current.appendChild(globeInstance.renderer.domElement);
        globeInstance.animate();
        globeInstanceRef.current = globeInstance;
        globeInstanceRef.current.updateSize();
        (window as any).globeInstance = globeInstance;
      }

    setFont();
  }, [])

  const switcher = useCallback(() => {
    if(globeInstanceRef.current) {
      const currentMode = globeInstanceRef.current.nextMode();
      setMode(currentMode);
    }
  }, [globeInstanceRef]);

  // 监听窗口大小变化
  const onResizeChange = useCallback(() => {
    if (globeInstanceRef.current) globeInstanceRef.current.updateSize();
    if (groundInstanceRef.current) groundInstanceRef.current.updateSize();
  }, []);

  useEffect(() => {
    window.addEventListener("resize", onResizeChange, false);
    return (): void => {
      window.removeEventListener("resize", onResizeChange);
    };
  }, [onResizeChange]);

  return (
    <div ref={mountRef} className={`mode-base mode-${mode}`}>
      {/* debug */}
      <canvas className="globe-canvas" ref={globeCanvasRef} />
      <canvas className="ground-canvas" ref={groundCanvasRef} />
      <Timer status={mode} />
      <div className="switcher" onClick={switcher}></div>
    </div>
  );
}

export default App;
